export default __webpack_public_path__ + "static/media/SEG-Education-Competency.fb33a2b4.png";